import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue'
import TabsContacts from '@/components/TabsContacts/index.vue'
import baseMessage from '@/views/gucangSales/customerCenter/components/baseMessage.vue'
import { potentialDetail } from '@/api/gucangSales/customerCenter'
import { useRoute } from 'vue-router'

const __default__ = {
  name: 'FbuClientsView'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  type: {
    type: String
  }
},
  setup(__props) {


const route = useRoute()
const data = ref({})
const loading = ref(false)
// 获取详情
const fetch = () => {
  if (route.query.cosId) {
    loading.value = true
    potentialDetail(route.query.cosId)
      .then((res) => {
        data.value = res.data
      })
      .finally(() => {
        loading.value = false
      })
  }
}
// 标签页切换
const changeTabs = (v: string) => {
  if (v === '1') {
    fetch()
  }
}
onMounted(() => {
  fetch()
})
// const permissionBasic = {
//   transfer: 'fbu_clients_transfer_btn',
//   follow_add: 'fbu_clients_follow_add_btn',
//   visitor_add: 'fbu_clients_visitor_add_btn',
//   edit: 'fbu_clients_edit_btn'
// }
// const permissionFollow = {
//   add: 'fbu_clients_follow_add_btn',
//   edit: 'fbu_clients_follow_edit_btn',
//   del: 'fbu_clients_follow_del_btn',
//   comment: 'fbu_clients_follow_comment_btn'
// }
// const permissionBuss = {
//   add: 'fbu_clients_buss_add_btn',
//   edit: 'fbu_clients_buss_edit_btn',
//   del: 'fbu_clients_buss_del_btn'
// }
// const permissionConcat = {
//   add: 'fbu_clients_concat_add_btn',
//   edit: 'fbu_clients_concat_edit_btn',
//   del: 'fbu_clients_concat_del_btn'
// }

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_CosViewContent, {
            header: "",
            title: data.value?.customerInfo?.customerName,
            sellerName: data.value?.customerInfo?.sellerName,
            customLabel: "联系人姓名",
            customValue: data.value?.contact?.name
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, { onChange: changeTabs }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "1",
                    tab: "基本信息"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(baseMessage, {
                        disabled: true,
                        formItemView: "",
                        data: data.value,
                        type: __props.type,
                        hideOk: true
                      }, null, 8, ["data", "type"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "2",
                    tab: "联系人"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TabsContacts, {
                        contactRefId: _unref(route).query.cosId,
                        appId: "cos_fbu",
                        hideOk: true
                      }, null, 8, ["contactRefId"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title", "sellerName", "customValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})